import { bundleConstants } from "../_constants/bundle.constants";

const initialState = {
  bundleCourses: [],
  loading: false,
};

export function bundleCourses(state = initialState, action) {
  switch (action.type) {
    case bundleConstants.FETCH_START:
      return {
        ...state,
        loading: true,
      };
    case bundleConstants.FETCH_END:
      return {
        ...state,
        loading: false,
      };
    case bundleConstants.SET_BUNDLE_COURSES: {
      return {
        ...state,
        bundleCourses: action.payload,
        loading: false,
      };
    }
    default:
      return state;
  }
}
